import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionLineageCountsFragmentGql } from './VirtualConnectionLineageCountsFragmentGql';

export const VirtualConnectionLineageCountsQueryGql: DocumentNode = gql`
query VirtualConnectionLineageCountsQuery($vizportalUrlId: String!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionLineageCountsFragment
  }
}
${VirtualConnectionLineageCountsFragmentGql}
`;
